import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const RainbowSix = () => {
  return (
    <SportsLayoutComp name={'Rainbow Six'}/>
  )
}

export default RainbowSix